import {getToken} from '../auth';
import request from "../request";
export default {

  /*
   * 字符串转换成数组
   * @param str  需要转换的字符串
   * @param splitChar  转换需要切割的字符
   * @returns []
   */
  strToArray(str, splitChar){
    if(splitChar == null || splitChar == undefined || splitChar == ''){
      splitChar = ',';
    }
    let result = [];
    if(str == null || str == '' || str == undefined){
      return result;
    }
    result = str.split(splitChar);
    return result;
  },

  /*
   * 数组转字符串
   */
  listToStr(list, splitChar){
    if(splitChar == null || splitChar == undefined || splitChar == ''){
      splitChar = ',';
    }
    if(list == null || list == undefined || list.length < 1){
      return '';
    }
    let ids = '';
    for(let i = 0; i < list.length; i++){
      ids = ids + list[i] + splitChar;
    }
    ids = ids.substring(0, ids.length - 1);
    return ids;
  },

  /*
   * 根据key获取label
   */
  findLabelByValue(list, value){
    let label = '';
    if(value == null || value == undefined || value == ''){
      label = ',';
    }
    for (let i = 0; i < list.length; i++) {
      let this_value = list[i]['value'];
      if(value == this_value){
        label = list[i]['label'];
      }
    }
    return label;
  },

  /*
   * 转义重组map
   * @param params
   * @returns {*}
   */
  recombinationMap(params){
    if(params == null || params == '' || params == undefined){
      return params
    }
    for(let key in params){
      let value = params[key];
      if(!!value && typeof params[key] == 'string' && value.indexOf('<') != -1){
        params[key] = value.replace('<','&lt;')
      }
      //
    }
    return params;
  },

  /*
   * 组装提示语句
   * @param params
   * @returns {*}
   */
  createValidMsg(obj){
    if(obj == null || obj == '' || obj == undefined){
      return '';
    }
    let a = [];
    for (let key in obj) {
      a.push(obj[key][0].message);
    }
    return  a[0];
  },

  /*
   * 组装 列表 中的checkbox的值
   * @param multipleSelection
   * @returns {undefined}
   */
  createListCheckboxValue(list) {
    if(list.length === 0){
      return '';
    }
    let ids = '';
    for(let i = 0;i < list.length;i++){
      ids = ids + list[i] + ",";
    }
    ids = ids.substring(0,ids.length-1);
    return ids;
  },

  /*
   * object 转 formData
   * @param object
   * @returns {FormData}
   */
  createFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach(key => {
      const value = object[key];
      if(Array.isArray(value)) {
        value.forEach((subValue, i) => {
          formData.append(key + `[${i}]`, subValue)
        })
      } else {
        formData.append(key, object[key])
      }
    })
    return formData;
  },

  /*
   * 根据列表获取某个字段的字符串列表（以逗号隔开）
   */
  createStrByList(list, columnName){
    if(list === null || list === undefined || list.length < 1){
      return '';
    }
    let ids = '';
    for(let i = 0; i < list.length; i++){
      if(list[i][columnName] === null || list[i][columnName] === undefined || list[i][columnName] === ''){
        continue;
      }
      if(ids === ''){
        ids = list[i][columnName]
      }else{
        ids += ',' + list[i][columnName]
      }
    }
    return ids;
  },


  /*
   * 根据列表获取某个字段的字符串列表（以逗号隔开）
   */
  exportReport(reportConfigId, reportName, businessId, fileName){
    return request({
      method:'get',
      url:'/web/exportReport',
      params: {
        reportConfigId: reportConfigId,
        reportName: reportName,
        businessId: businessId
      },
      responseType: `arraybuffer`
    }).then((response) =>{
      if(response.code == '1'){
        this.$message({
          type: "error",
          message: response.msg
        })
        return false
      }
      let blob = new Blob([response], {
        type: `application/msword`
      });
      let objectUrl = URL.createObjectURL(blob);
      let link = document.createElement("a");
      let fname = fileName + `.docx`; //下载文件的名字
      link.href = objectUrl;
      link.setAttribute("download", fname);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(link.href)
    })
  },

  //限制input金额为数字且保留2位小数
  limitMoneyInput(inputValue, decimalLimit = 2) {
    // 将非数字、非小数点的字符替换为空字符串
    inputValue = inputValue.replace(/[^0-9.]/g, '');

    // 对输入值进行小数点位数的限制
    const dotIndex = inputValue.indexOf('.');
    if (dotIndex !== -1) { // 如果输入值中包含小数点
      if (inputValue.length - dotIndex > decimalLimit + 1) { // 如果小数点后超过所需位数
        inputValue = inputValue.slice(0, dotIndex + decimalLimit + 1); // 截取小数点后指定位数
      }
    }

    return inputValue;
  },

  /*
   *向系统发出通知
   * msg 消息内容
   * url 点击后跳转地址
   * icon 图标地址
   */
  initNotification(msg,url,icon){
    if (icon == null){
      icon = ''
    }
    if (window.Notification) {
      /* 授权过通知 */
      if (Notification.permission === 'granted') {
        const notification = new Notification('你好', {
          icon: icon,
          body: msg
        })
        notification.onclick = function () {
          window.open(url)
          notification.close()
        }
        //30秒后自动关闭
        setTimeout(notification.close.bind(notification), 30*1000);
      } else {
        /* 未授权，先询问授权 */
        Notification.requestPermission();//设置允许通知
      }
    }
  },

}







// WEBPACK FOOTER //
// ./src/utils/xhh/common.js